import appSettings from './app-settings.json';

export const awsConfig = {
  Auth: {
    Cognito: {
      region: appSettings.region,
      userPoolId: appSettings.cognitoUserPool,
      userPoolClientId: appSettings.cognitoUserPoolWebClientId,
    },
  },
};
